/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Insert_Full_BlockInputs */



/**
* | output |
* | --- |
* | "Insert full block" |
*
* @param {Insert_Full_BlockInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const insert_full_block = /** @type {((inputs?: Insert_Full_BlockInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Insert_Full_BlockInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Insérer un bloc plein")
	if (locale === "de") return /** @type {LocalizedString} */ ("Vollständigen Block einfügen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Inserisci blocco completo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Вставить полный блок")
	if (locale === "es") return /** @type {LocalizedString} */ ("Insertar bloque completo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("插入完整块")
	if (locale === "ja") return /** @type {LocalizedString} */ ("完全なブロックを挿入")
	if (locale === "hi") return /** @type {LocalizedString} */ ("पूरा ब्लॉक डालें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Inserir bloco completo")
	return /** @type {LocalizedString} */ ("Insert full block")
});